<template>
    <div :class="size === 'small' ? 'flex flex-wrap gap-2' : 'flex flex-col gap-3 sm:flex-row'">
        <button
            type="button"
            :class="buttonClass(true)"
            :disabled="disabled"
            :data-testid="testId ? `${testId}-yes` : undefined"
            @click="select(true)"
        >
            <icon v-if="size !== 'small' && modelValue === true && yesIcon" :icon="yesIcon" class="me-2" />
            <span class="capitalize">{{ yesLabel }}</span>
        </button>
        <button
            type="button"
            :class="buttonClass(false)"
            :disabled="disabled"
            :data-testid="testId ? `${testId}-no` : undefined"
            @click="select(false)"
        >
            <icon v-if="size !== 'small' && modelValue === false && noIcon" :icon="noIcon" class="me-2" />
            <span class="capitalize">{{ noLabel }}</span>
        </button>
    </div>
</template>

<script setup>
import { trans } from '@/mixins/i18n.js';

const props = defineProps({
    modelValue: { type: Boolean },
    yesLabel: { type: String, default: () => trans('general.yes') },
    noLabel: { type: String, default: () => trans('general.no') },
    yesSelectedClass: { type: String, default: 'bg-success-subtle border-success-subtle text-success-emphasis' },
    noSelectedClass: { type: String, default: 'bg-danger-subtle border-danger-subtle text-danger-emphasis' },
    yesIcon: { type: String, default: 'cil-check-alt' },
    noIcon: { type: String, default: 'cil-x' },
    size: { type: String, default: 'large' },
    disabled: { type: Boolean, default: false },
    testId: { type: String, default: null },
});

const emit = defineEmits(['update:modelValue']);

const buttonClass = (isYes) => {
    const selected = props.modelValue === isYes;
    const sizeClass = props.size === 'small' ? 'rounded-lg! px-5 py-1 text-sm font-semibold' : 'flex-1 rounded-lg! px-4 py-1.5 text-sm font-semibold';
    const baseBorder = 'border';
    const idleClass = 'bg-white border-gray-light text-body hover:border-gray-text';
    const selectedClass = isYes ? props.yesSelectedClass : props.noSelectedClass;
    const disabledClass = props.disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer';

    return `${baseBorder} ${sizeClass} ${selected ? selectedClass : idleClass} ${disabledClass}`;
};

const select = (value) => {
    if (props.disabled) {
        return;
    }
    emit('update:modelValue', value);
};
</script>
